// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json_decode from "../../../../../../../../node_modules/@glennsl/bs-json/src/Json_decode.mjs";

function execute(json) {
  return {
          shift_req_external_id: Json_decode.at({
                  hd: "sr_external_id",
                  tl: /* [] */0
                }, Json_decode.string)(json)
        };
}

export {
  execute ,
}
/* No side effect */
